"use strict";

/**
 * Show dropdown with suggestions on typing in search box
 */
;

(function () {
  //var endpoint = 'https://ac2.tnaflix.com?q=';
  var endpoint = '/auto-complete?q=';
  /**
   * @type {HTMLElement}
   */

  var searchBox;
  /**
   * @type {HTMLElement}
   */

  var dropdownWrapper;
  var cache = {},
      timeoutTimer;
  /**
   * Main logic
   */

  function onPageLoad() {
    var _searchBox, _searchBox2;

    searchBox = document.querySelector('#mainsearch input');
    dropdownWrapper = document.querySelector('#prediction');
    (_searchBox = searchBox) === null || _searchBox === void 0 ? void 0 : _searchBox.addEventListener('keyup', suggest);
    (_searchBox2 = searchBox) === null || _searchBox2 === void 0 ? void 0 : _searchBox2.addEventListener('blur', function () {
      return removeDropdown(true);
    });
  }
  /**
   * Send request to endpoint and show dropdown with suggests
   */


  function suggest() {
    if (searchBox.value.length > 2) {
      if (cache.hasOwnProperty(searchBox.value)) {
        showDropDown(cache[searchBox.value]);
      } else {
        if (timeoutTimer) {
          clearTimeout(timeoutTimer);
        }

        timeoutTimer = setTimeout(function () {
          FlixUtils.request(endpoint + encodeURIComponent(searchBox.value), {
            cb: function cb(xhr) {
              return xhr.responseType = 'json';
            }
          }).then(function (json) {
            cache[searchBox.value] = json; // Cache results in memory

            return json;
          }).then(function (json) {
            return showDropDown(json);
          });
        }, 300);
      }
    } else {
      removeDropdown();
    }

    try {
      localStorage.setItem('search_source', 'input');
    } catch (e) {}
  }
  /**
   * @param {Array} jsonSuggestions array of objects
   */


  function showDropDown(jsonSuggestions) {
    // Show dropdown only if there are some results
    if (jsonSuggestions.length) {
      var html = '',
          currentType,
          divider,
          path; // Prepare html

      jsonSuggestions.forEach(function (el) {
        if (currentType != el.type) {
          currentType = el.type;
          var tp = el.type == '1' ? 'Pornstar' : el.type == '3' ? 'Channel' : 'Suggestions';
          html += "<div class=\"suggestedItem suggestedDivider\"><div class=\"suggestedWord\">".concat(tp, "</div></div>");
        }

        switch (el.type) {
          case '4':
            path = el.entity_value;
            break;

          case '1':
            path = "profile/".concat(el.entity_value, "?section=videos");
            break;

          case '3':
            path = "channel/".concat(el.entity_value);
            break;

          default:
            path = "search?what=".concat(el.term);
            break;
        } //remove domain to save it for mobile/desk versions


        html += "<div class=\"suggestedItem\"><div class=\"suggestedWord\"><a href=\"/".concat(path, "\">").concat(el.term, "</a></div></div>");
      });
      dropdownWrapper.innerHTML = html;
      dropdownWrapper.style.display = 'block';
      document.querySelectorAll('.suggestedWord > a').forEach(function (el) {
        el.addEventListener('click', function () {
          try {
            localStorage.setItem('search_source', 'suggest');
          } catch (e) {}
        });
      });
    } else {
      // Otherwise remove dropdown
      removeDropdown();
    }
  }
  /**
   * @param {boolean} withDelay required for the "blur" event. Without timeout dropdown closes faster than click on the suggested link happens
   */


  function removeDropdown() {
    var withDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (timeoutTimer) {
      clearTimeout(timeoutTimer);
    }

    timeoutTimer = setTimeout(function () {
      dropdownWrapper.innerHTML = '';
      dropdownWrapper.style.display = 'none';
    }, withDelay ? 300 : 0);
  } // All logic will be executed after page load


  document.addEventListener('DOMContentLoaded', onPageLoad);
})();